import React from "react";

const Logo = () => {
    return (
        <div className="logo">
            <div className="icon"></div>
            <h1>Academie Avenir</h1>
        </div>
    )
}

export default Logo;
